import { useState } from 'react';

import type { RequestError } from './loadable';
import { reloadPage } from './reloadPage';
import { useResetDiagnosticsMutation } from './resetApi';
import ResetDiagnosticsView from './ResetDiagnosticsView';

type ResetDiagnosticsProps = {
  detectionRunning: boolean;
};

function ResetDiagnostics({ detectionRunning }: ResetDiagnosticsProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [phrase, setPhrase] = useState('');
  const [refusal, setRefusal] = useState<RequestError>();
  const [resetDiagnostics, { isLoading: resetting }] = useResetDiagnosticsMutation();

  const close = (): void => {
    setOpen(false);
    setPhrase('');
    setRefusal(undefined);
  };

  const confirm = async (): Promise<void> => {
    const answer = await resetDiagnostics({ phrase });
    if ('error' in answer) {
      setRefusal(answer.error);
      return;
    }

    setOpen(false);
    reloadPage();
  };

  return (
    <ResetDiagnosticsView
      detectionRunning={detectionRunning}
      open={open}
      phrase={phrase}
      resetting={resetting}
      refusal={refusal}
      onOpen={() => setOpen(true)}
      onPhraseChange={setPhrase}
      onCancel={close}
      onConfirm={() => {
        void confirm();
      }}
    />
  );
}

export default ResetDiagnostics;
